import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import SettingsButton from './SettingsButton';
import media from '../style/media';
import { Flex } from './shared/Flex';

const Wrapper = styled(Flex)`
  width: 100%;
  position: relative;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  z-index: 2;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(37, 99, 235, 0.1);
  
  ${media.tablet`
    padding: 0 40px;
  `}
  
  padding: 0 20px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

const PoweredBy = styled.span`
  color: var(--cl-text-light);
  font-size: 12px;
  font-weight: 400;
  margin-right: 15px;
  
  ${media.mobile`
    display: none;
  `}
`;

const TopBar = ({ onSettingsClick, isMeasuring }) => {
  return (
    <Wrapper>
      <Logo />
      <RightSection>
        <PoweredBy>Powered by Advanced AI Technology</PoweredBy>
        <SettingsButton disable={isMeasuring} onClick={onSettingsClick} />
      </RightSection>
    </Wrapper>
  );
};

export default TopBar;
